/** Hook và tiện ích dùng chung cho UI. */
import { useEffect, useState } from 'preact/hooks';
import type { GameController } from './game-controller.js';

/** Vẽ lại component mỗi khi controller thông báo state đổi. */
export function useCapNhat(controller: GameController): void {
  const [, setDem] = useState(0);
  useEffect(() => controller.theoDoi(() => setDem((d) => d + 1)), [controller]);
}

/** Định dạng xu kiểu Việt Nam. */
export function dinhDangXu(xu: number): string {
  return `${Math.floor(xu).toLocaleString('vi-VN')} xu`;
}

/** XP tích lũy cần để đạt cấp n (suy từ decisions-m1.md mục 8). */
export function xpCanChoCap(n: number): number {
  return (100 * n * (n - 1)) / 2;
}

const KIEU_PANEL =
  'background: rgba(20, 14, 8, 0.88); color: #f5e9d0; border: 1px solid #8a6a3a; ' +
  'border-radius: 10px; padding: 12px;';

/** Style inline dùng chung cho panel UI. */
export const stylePanel = KIEU_PANEL;

export const styleNutChinh =
  'background: #c98a2e; color: #1d130a; border: none; border-radius: 8px; ' +
  'padding: 8px 14px; font-weight: 700; cursor: pointer;';

export const styleNutPhu =
  'background: transparent; color: #f5e9d0; border: 1px solid #8a6a3a; ' +
  'border-radius: 8px; padding: 8px 14px; cursor: pointer;';
